import styled from 'styled-components';

export const StyledBabaTimerBadge = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  width: 74px;
  z-index: 1;
  top: 59%;
  transform: translateY(-50%);
  left: -7px;

  img {
    width: 100%;
    height: auto;
  }

  .timer-badge-text {
    color: #fff;
    text-align: center;
    text-shadow: 0px 1px 1px #000;
    font-size: 10px;
    font-weight: 400;
    position: absolute;
    left: 50%;
    bottom: 42%;
    transform: translateX(-50%);
  }
` as any;
